export const BUTTON_WIDTH = 48; // Width of each button in pixels
export const CONTAINER_PADDING = 20; // Padding around the button group in pixels
export const MAX_VISIBLE_BUTTONS = 4; // Maximum number of buttons to show
export const HEADER_RESPONSIVE_BREAKPOINT = 718; // Breakpoint for header responsive behavior
